export default "__VITE_ASSET__Bc3JVBZe__"